module.exports = __webpack_public_path__ + "img/switzerland-pneumonia-male.50ce9dee.png";